module.exports = "\ntr {\n    font-size: 0.8em;\n}\ntd {\n    font-size: 0.8em;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-transactions/my-transactions.component.css
// module id = ./src/app/my-transactions/my-transactions.component.css
// module chunks = main